export default {
  paymentMethod: 'card',
  paymentPrice: 0,
  __typename: 'Checkout'
};
